import cn from 'classnames';
import { FC } from 'react';
import { CancelIcon } from '../../../../../../assets/svg/cancel';
import { EditIcon } from '../../../../../../assets/svg/edit';
import { EyeIcon } from '../../../../../../assets/svg/eye';
import { Button } from '../../../../../../components/button/button';
import { RolePermission } from '../../../../../../store/api/role-api';
import s from './roles-and-access-button.module.css';

interface Props {
  permission?: RolePermission;
  onChange: (permission?: RolePermission) => void;
}

export const RolesAndAccessButton: FC<Props> = ({ permission, onChange }) => {
  const resultPermission = permission || 'none';

  const handleClick = () => {
    if (resultPermission === 'none') {
      onChange('read');
    }
    if (resultPermission === 'read') {
      onChange('write');
    }
    if (resultPermission === 'write') {
      onChange(undefined);
    }
  };

  return (
    <Button
      className={cn(s.feature, s[resultPermission])}
      fullWidth
      size="lg"
      onClick={handleClick}
    >
      {resultPermission === 'read' && <EyeIcon />}
      {resultPermission === 'write' && (
        <>
          <EyeIcon />
          <EditIcon />
        </>
      )}
      {resultPermission === 'none' && <CancelIcon />}
    </Button>
  );
};
